import { useAuth } from '@/features/auth';
import { useCatalog } from '../state/use-catalog';
import { useModuleFilters } from '../state/use-module-filters';
import { GalleryControls } from './GalleryControls';
import { ModuleGrid } from './ModuleGrid';
import styles from './Gallery.module.css';

export function Gallery() {
  const { state, user } = useAuth();
  const { modules, isLoading, error, source } = useCatalog();
  const { filters, filteredModules, setStatus, setVisibility, setSearch } =
    useModuleFilters(modules);

  const isAuthenticated = state === 'authenticated';
  const userId = user?.id ?? null;

  if (isLoading) {
    return (
      <section className={styles.gallery} id="gallery">
        <div className={styles.loading}>
          <p>Loading modules...</p>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className={styles.gallery} id="gallery">
        <div className={styles.error}>
          <p>Failed to load modules. Please try again later.</p>
        </div>
      </section>
    );
  }

  return (
    <section className={styles.gallery} id="gallery">
      <GalleryControls
        filters={filters}
        onStatusChange={setStatus}
        onVisibilityChange={setVisibility}
        onSearchChange={setSearch}
      />
      <ModuleGrid modules={filteredModules} isAuthenticated={isAuthenticated} userId={userId} />
      {source === 'static' && (
        <p className={styles.sourceHint}>
          <span className="visually-hidden">Catalog loaded from static fallback</span>
        </p>
      )}
    </section>
  );
}
